module.exports = __webpack_public_path__ + "img/un.e6aabbd5.svg";